import { NgxUiLoaderConfig, NgxUiLoaderHttpConfig, NgxUiLoaderRouterConfig, PB_DIRECTION, POSITION, SPINNER } from 'ngx-ui-loader';
import { environment as env } from 'src/environments/environment';

export const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#150F96',
  bgsOpacity: 1,
  bgsPosition: POSITION.bottomRight,
  bgsSize: 25,
  bgsType: SPINNER.ballSpinClockwise,
  blur: 2,
  fgsColor: '#150F96',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 80,
  fgsType: SPINNER.ballSpinClockwise,
  gap: 44,
  logoPosition: POSITION.centerCenter,
  logoSize: 120,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: 'rgba(255, 255, 255, 0.9)',
  pbColor: '#150F96',
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 5, // progress bar thickness
  hasProgressBar: true,
  text: '',
  textColor: '#150F96',
  textPosition: POSITION.centerCenter,
  threshold: 500
};

export const ngxUiLoaderRouterConfig: NgxUiLoaderRouterConfig = {
  loaderId: 'router-loader',
  showForeground: true
};

export const ngxUiLoaderHttpConfig: NgxUiLoaderHttpConfig = {
  loaderId: 'http-loader',
  // showForeground: false
  showForeground: true,
  exclude: [`${env.apiEndpoint}/quickQuote/generatePDF/?quotationId=`]
};
